import { IconNames } from 'components/Icon/Icon';
import { Event } from 'types/Event';

export type EventColors = {
  textColor: string;
  border: string;
  backgroundColor: string;
  iconName: IconNames;
  label: string;
  transparency: string;
};

export interface getEventColorsProps {
  event: Event & { isModified?: boolean };
  outlined?: boolean;
}

export const getEventColors = ({ event, outlined = false }: getEventColorsProps): EventColors => {
  let textColor = 'text-primary';
  let border = '';
  let bgColor = 'bg-light';
  let iconName: IconNames = 'ClockIcon';
  let label = '?';
  let transparency = '';

  if (event?.eventType === 'personal') {
    switch (event?.meeting?.status) {
      case 'new':
        textColor = 'text-black';
        border = 'border border-black';
        bgColor = 'bg-yellow-300';
        iconName = 'PlusCircleIcon';
        label = 'Nouvel événement';
        break;
      default:
        textColor = outlined ? 'text-stone-600' : 'text-stone-600';
        border = outlined ? 'border border-dark' : 'border border-stone-500';
        bgColor = outlined ? 'bg-white' : 'bg-stone-100';
        iconName = 'PersonalEventIcon';
        label = 'Evènement personnel';
        break;
    }
    if (event.isModified && event.meeting?.status !== 'new') {
      textColor = 'font-bold text-white';
      bgColor = 'bg-stone-500';
      border = 'border border-stone-500';
    }
  } else if (event?.eventType === 'availability') {
    switch (event?.meeting?.status) {
      case 'new':
        textColor = 'text-black';
        border = 'border border-black';
        bgColor = 'bg-sky-300';
        iconName = 'PlusCircleIcon';
        label = 'Nouvelle disponibilité';
        break;
      default:
        textColor = outlined ? 'text-[#0284c7]' : 'text-[#0284c7]';
        border = outlined ? 'border border-dark' : 'border border-[#0284c7]';
        bgColor = outlined ? 'bg-white' : 'bg-[rgba(2,132,199,0.15)]';
        iconName = 'AvailabilityEventIcon';
        label = 'Disponibilité';
        break;
    }
    if (event.isModified && event.meeting?.status !== 'new') {
      textColor = 'font-bold text-white';
      bgColor = 'bg-[#0284c7]';
      border = 'border border-[#0284c7]';
    }
  } else {
    // eventType = 'meeting'
    switch (event?.meeting?.status) {
      case 'cancelled':
        textColor = outlined ? 'text-stone-400' : 'text-stone-400';
        border = outlined ? 'border border-dark' : 'border border-stone-300';
        bgColor = outlined ? 'bg-white' : 'bg-stone-50';
        iconName = 'TrashIcon';
        label = 'Annulé';
        transparency = 'opacity-70';
        break;
      case 'accepted':
        textColor = outlined ? 'text-[#0284c7]' : 'text-white';
        border = outlined ? 'border border-[#0284c7]' : '';
        bgColor = outlined ? 'bg-white' : 'bg-[#0284c7]';
        iconName = 'CheckIcon';
        label = 'Accepté';
        break;
      case 'denied':
        textColor = outlined ? 'text-red-500' : 'text-red-500';
        border = outlined ? 'border border-red-500' : 'border border-red-500';
        bgColor = outlined ? 'bg-white' : 'bg-red-100';
        iconName = 'XMarkIcon';
        label = 'Refusé';
        transparency = 'opacity-50';
        break;
      case 'rescheduled_by_mediator':
        textColor = outlined ? 'text-red-500' : 'text-red-500';
        border = outlined ? 'border border-red-500' : 'border border-red-500';
        bgColor = outlined ? 'bg-white' : 'bg-red-100';
        iconName = 'RescheduleIcon';
        label = 'Reporté';
        transparency = 'opacity-50';
        break;
      case 'pending':
        textColor = outlined ? 'text-orange-600' : 'text-white';
        border = outlined ? 'border border-orange-500' : '';
        bgColor = outlined ? 'bg-white' : 'bg-orange-400';
        iconName = 'ClockIcon';
        label = 'En attente';
        break;
      case 'rescheduled_by_applicant':
        textColor = outlined ? 'text-orange-600' : 'text-white';
        border = outlined ? 'border border-orange-500' : '';
        bgColor = outlined ? 'bg-white' : 'bg-orange-400';
        iconName = 'RescheduleIcon';
        label = 'En attente';
        break;
      default: // 'new' status falls here
        textColor = 'text-black';
        border = 'border border-black';
        bgColor = 'bg-yellow-300';
        iconName = 'PlusCircleIcon';
        label = 'Nouvel événement';
        break;
    }
    if (event.isModified && event.meeting?.status !== 'new') {
      textColor = 'font-bold text-white';
    }
  }

  return { textColor, border, backgroundColor: bgColor, iconName, label, transparency };
};
